import React from 'react';
import { isMobile } from 'react-device-detect';
import styles from './Footer.module.css';
import { useLocation } from 'react-router-dom';

function Footer(props) {
  const location = useLocation();
  let expansion = '';

  if (props.stickyBarActive && location.pathname.split('/')[2] === 'stepOne') {
    expansion = styles.expanded;
  }

  const currentYear = new Date().getFullYear();

  return (
    <footer className={`${styles.footer} ${expansion} ${isMobile && styles.mobile}`}>
      <div className={styles.footerContent}>
        <a href="https://www.adways.com/en/terms" target="_blank" rel="noopener noreferrer">
          Terms & Conditions
        </a>{' '}
        <a href="https://www.adways.com/en/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Statement
        </a>{' '}
        <span>Product of Adways · Weborama {currentYear}</span>
      </div>{' '}
    </footer>
  );
}

export default Footer;
